import {IElement, IImageAttributes} from 'routes/private/Editor/types';

export const updateBrandImage = ( element: IElement, value: {srcImage: string,brandImage: string, brandId: string, brandImageType: string , width: number, height: number} ) => {
  if (element.type === 'Image') {  
  (element.attributes as IImageAttributes).srcImage = undefined;  
  (element.attributes as IImageAttributes).brandId  = value.brandId;
  (element.attributes as IImageAttributes).brandImageType  = value.brandImageType;

  const width = element.attributes.image.width, height = element.attributes.image.height, imageWidth = value.width, imageHeight = value.height;
  const ratio = width / height;
  const imageRatio = imageWidth / imageHeight;
  if (ratio !== imageRatio) {
    let x = element.attributes.image.x, y = element.attributes.image.y;
    const modifiedWidth = height * imageRatio;
    const modifiedX = x + (width - modifiedWidth) / 2;
    element.attributes.height = height;
    element.attributes.width = modifiedWidth;
    element.attributes.image.width = modifiedWidth;
    element.attributes.y = y;
    element.attributes.x = modifiedX;
    element.attributes.image.x = modifiedX;
  }
}
  return element;
}


